import { optimalBluePricingApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CUSTOM_FIELDS_ACTION_TYPE = createNamedActions('pricing/customFields', {
  GET_CUSTOM_FIELDS: 'GET_CUSTOM_FIELDS',
});

export const getCustomFieldsAction = catchAsyncActionError(
  ({ applicationId }) =>
    async dispatch => {
      const { data } = await optimalBluePricingApi.getCustomFields({ applicationId });

      return dispatch({
        type: CUSTOM_FIELDS_ACTION_TYPE.GET_CUSTOM_FIELDS,
        payload: data,
      });
    },
);
